import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "post__content custom-scrollbar" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-center text-grey-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.content !== null && !_ctx.post.isPrivate)
      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, null, 512)), [
          [_directive_dompurify_html, _ctx.content, "postContent"]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.post.isPrivate)
        ? (_openBlock(), _createElementBlock("em", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.clientName) + " shared a post created by another user. Due to permissions set by the post author, we are unable to pull this post into Private Footprint. Click ", 1),
            _createElementVNode("a", {
              href: _ctx.post.link
            }, "here", 8, _hoisted_5),
            _createTextVNode(" to view this post on " + _toDisplayString(_ctx.post.socialSite.name) + " (if you are connected to " + _toDisplayString(_ctx.clientName) + "). ", 1)
          ]))
        : (!_ctx.post.content)
          ? (_openBlock(), _createElementBlock("em", _hoisted_6, "This post has no text content."))
          : _createCommentVNode("", true)
    ])
  ]))
}